<template>
  <div>
  <header>
      <div class="container">
        <div class="logo">
          <img src="../assets/img/Logo.png"  style="max-width:300px" alt="" />
        </div>
        <div class="text">
          <h1>Velórios <br />Virtuais</h1>
          <h3>Você mais presente.</h3>
        </div>
      </div>
    </header>
     <section class="s-hero">
      <div class="container">
        <iframe
          src="https://www.adiau.net/validacao/index.php?ipc=1652704302&id=165&token=750ed4ec57a6819ac76b18a5910553aa&color1=******&color2=******&color3=******&color4=******&color5=******#"
          title="Velório Virtual"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </section>

   <section class="s-contact">
      <div class="container">
        <div class="contacts-left">
          <div class="contact">
            <img src="../assets/img/flower.png" alt="" />
             
            <h3>🔸Floricultura:</h3>
            <p>Telefone para vendas:</p>
            <span>(82) 3336-4050/9984-7000(Whatsapp)</span>
          </div>

          <div class="contact">
            <img src="../assets/img/24.png" alt="" />
            <h3>🔸Atendimento 24h:</h3>
            <span>0800 009 1700</span>
          </div>
        </div>

        <div class="contacts-right">
          <div class="contact">
            <img src="../assets/img/whatsapp.png" alt="" />
            <h3>🔸Central de vendas (Whatsapp)</h3>
            <p>Planos previda:</p>
            <span>0800 009 1700</span>
          </div>

          <div class="contact">
            <img src="../assets/img/arroba.png" alt="" />
            <h3>🔸Atendimento online:</h3>
            <span>contato@previda.com.br</span>
          </div>
        </div>
      </div>
    </section>

    <footer>
      <div class="container">
        <div class="img-left">
          <img src="../assets/img/Left.png" alt="" />
        </div>
        <div class="social">
         
         <!-- <div class="icones">
            <a href="https://api.whatsapp.com/send?phone=5582982121700&text=Acesso%20via%20site%3A%20Ol%C3%A1%2C%20quero%20entrar%20em%20contato%20com%20o%20Previda" target="_blank"><img src="../assets/img/whatsapp.png" alt="" class="icone" /></a>
            <a href="https://www.instagram.com/previda_/" target="_blank"><img src="../assets/img/instagram.png" alt="" class="icone" /></a>
            <a href="https://www.facebook.com/PrevidaAlagoas" target="_blank"><img src="../assets/img/facebook.png" alt="" class="icone" /></a>
        
          </div>
          -->
            <div class="icones">
         
            <v-btn href="https://api.whatsapp.com/send?phone=8000091700&text=Acesso%20via%20site%3A%20Ol%C3%A1%2C%20quero%20entrar%20em%20contato%20com%20o%20Previda" target="_blank" color="#0a5587" fab  x-large  dark>
              <v-icon>mdi-whatsapp</v-icon>
            </v-btn>

            <v-btn href="https://www.instagram.com/previda_/" target="_blank" color="#0a5587" fab  x-large  dark>
              <v-icon>mdi-instagram</v-icon>
            </v-btn>

            <v-btn href="https://www.facebook.com/PrevidaAlagoas"  target="_blank" color="#0a5587" fab  x-large  dark>
              <v-icon>mdi-facebook</v-icon>
            </v-btn>



          </div>
          <div class="text">
            <p>Rua José Alencar, nº 121, Maceió</p>
            <p>{{ new Date().getFullYear() }} -<strong> Previda</strong></p>
          </div>
        </div>
        <div class="img-right">
          <img src="../assets/img/Right.png" alt="" />
        </div>
      </div>
    </footer>

  </div>  
</template>

<script>

export default {

data: () => ({
      //color: 'background-color:#f5f5f5;',
            icons: [
                //'mdi-facebook',
                //'mdi-whatsapp',
                //'mdi-instagram',
            ],

  }),



}
</script>


<style scoped> 


*{margin:0;padding:0;list-style:none;text-decoration:none;outline:none;border:none;box-sizing:border-box;font-family:"Inter", sans-serif}img{display:block;max-width:80%}html{font-size:22.5%}@media (max-width: 1300px){html{font-size:18%}}@media (max-width: 90px){html{font-size:1.5%}}@media (max-width: 20px){html{font-size:28%}}html,body{overflow-x:hidden}button{background-color:transparent;cursor:pointer}.container{width:90%;max-width:147rem;padding:1.5rem;margin:0 auto}header{background:#f3f1f1;padding:3rem 0}header .container{display:flex;flex-direction:row;align-items:center;justify-content:space-between}header .container .text h1{text-transform:uppercase;font-size:2rem;margin-bottom:0.1rem;color:#0a5587;text-align:right}header .container .text h3{background:#d7ecfa;font-size:1.2rem;color:#3b8fc7;text-align:left;letter-spacing:0.3rem}@media (max-width: 100px){header .container{flex-direction:column}}@media (max-width: 480px){header .container .text h1{font-size:2rem}header .container .text h3{font-size:2rem}}footer{position:relative;padding-bottom:0}footer .container{display:flex;flex-direction:row;align-items:center;justify-content:center;padding-bottom:0;height:25rem}footer .container .img-left{position:absolute;bottom:0;left:0}footer .container .img-right{position:absolute;bottom:0;right:0}footer .container .social{width:50%}footer .container .social .icones{display:flex;flex-direction:row;align-items:center;justify-content:space-around;width:100%}footer .container .social .icones .icone{background:#0a5587;width:74px;height:74px;padding:1.2rem;border-radius:25%}footer .container .social .text{margin-top:4rem}footer .container .social .text p{text-align:center;font-size:1rem;color:#0a5587;letter-spacing:0.2rem}footer .container .social .text p:last-child{margin-top:1rem}@media (max-width: 1160px){footer .container{height:55rem}footer .container .img-left,footer .container .img-right{max-width:25%}footer .container .social .text p{font-size:2rem}}@media (max-width: 480px){footer .container{height:35rem}footer .container .social{width:100%}}.s-hero .container{display:flex;flex-direction:row;align-items:center;justify-content:center;padding:2rem 0}.s-hero .container iframe{width:100%;max-width:98%;height:45rem}.s-contact{padding:1rem 0}.s-contact .container{display:flex;flex-direction:row;align-items:center;justify-content:space-around}.s-contact .container .contacts-left .contact,.s-contact .container .contacts-right .contact{display:flex;flex-direction:column;align-items:flex-start;margin-bottom:0.1rem;padding-bottom:5rem}.s-contact .container .contacts-left .contact:last-child,.s-contact .container .contacts-right .contact:last-child{margin-bottom:0}.s-contact .container .contacts-left .contact img,.s-contact .container .contacts-right .contact img{background:#0a5587;width:48px;height:48px;margin-left:2rem;padding:0.6rem;border-radius:25%}.s-contact .container .contacts-left .contact h3,.s-contact .container .contacts-right .contact h3{font-size:1.2rem;color:#0a5587;text-transform:uppercase}.s-contact .container .contacts-left .contact p,.s-contact .container .contacts-right .contact p{font-size:1rem;padding-left:1rem;color:#3b8fc7;margin-top:0.2rem}.s-contact .container .contacts-left .contact span,.s-contact .container .contacts-right .contact span{background:#f29127;margin-left:1rem;font-size:1.2rem;padding:0.1rem;color:#fff;margin-top:0.1rem}@media (max-width: 1000px){.s-contact{padding:0}.s-contact .container{align-items:center;flex-direction:column;align-items:center}.s-contact .container .contacts-left .contact,.s-contact .container .contacts-right .contact{align-items:center;margin:0}.s-contact .container .contacts-left .contact h3,.s-contact .container .contacts-right .contact h3{text-align:center}}@media (max-width: 80px){.s-contact .container .contacts-left .contact h3,.s-contact .container .contacts-right .contact h3{font-size:2rem}}



</style>


